{
  "big_actions": "よく使う操作",
  "new_orders_other": "新着 {{count}}",
  "new_orders_banner_other": "新しい注文が {{count}} 件届きました",
  "see_orders": "注文を見る",
  "sound": "新しい注文の音",
  "todo": {
    "title": "今日やること",
    "do_it": "今すぐ",
    "all_done": "待っているものはありません。お疲れさまです。",
    "could_not_check": "確認できなかったもの",
    "retry": "もう一度",
    "rows": {
      "bank_transfers_other": "入金確認待ちの振込 {{count}} 件",
      "payments_overdue_other": "期限切れの振込 {{count}} 件",
      "to_ship_other": "準備・発送する注文 {{count}} 件",
      "pickup_ready_other": "店頭受取待ち {{count}} 件",
      "export_missing_evidence_other": "輸出証明がない海外注文 {{count}} 件",
      "returns_other": "対応する返品 {{count}} 件",
      "flagged_other": "確認が必要な注文 {{count}} 件",
      "no_photos_other": "画像がない商品 {{count}} 件",
      "no_price_other": "価格がない商品 {{count}} 件",
      "unverified_compare_at_other": "根拠のない元値 {{count}} 件",
      "prices_to_check_other": "価格の確認が必要な商品 {{count}} 件",
      "sold_twice_other": "二重に売れたカード {{count}} 件",
      "stock_differences_other": "在庫の差異 {{count}} 件",
      "old_holds_other": "1日以上取り置き中のカード {{count}} 件",
      "undelivered_messages_other": "届かなかったシステムの処理 {{count}} 件",
      "taxfree_failed_other": "失敗した免税返金 {{count}} 件",
      "taxfree_deadline_other": "90日期限が近い免税販売 {{count}} 件",
      "taxfree_refund_due_other": "支払う免税返金 {{count}} 件",
      "payouts_due_other": "支払う委託販売 {{count}} 件",
      "kobutsu_incomplete_other": "不備のある古物台帳 {{count}} 件",
      "shift_variance_one": "確認が必要なレジの過不足 {{count}} 件",
      "shift_variance_other": "確認が必要なレジの過不足 {{count}} 件"
    },
    "hints": {
      "bank_transfers": "お客様から振込の連絡があります。口座を確認して入金確認してください。",
      "payments_overdue": "支払期限を過ぎています。お客様に連絡するかキャンセルしてください。",
      "to_ship": "支払い済みで準備・発送を待っている注文です。",
      "pickup_ready": "お客様が来店します。お渡ししてください。",
      "export_missing_evidence": "輸出免税のために発送の証明を追加してください。",
      "returns": "承認・受け取り・返金をしてください。",
      "flagged": "発送前にもう一度確認するよう印が付いています。",
      "no_photos": "見えるものが売れます。写真を追加してください。",
      "no_price": "下書きを仕上げてください（状態・価格・在庫）。",
      "unverified_compare_at": "二重価格には根拠（8週間／メーカー価格）が必要です。直すか消してください。",
      "prices_to_check": "長いあいだ確認していない価格（赤）です。相場を見て「この価格で問題なし」を押すか、価格を変えてください。",
      "sold_twice": "どのお客様に渡すか決めて、もう一方に連絡してください。",
      "stock_differences": "夜間チェックで数が合わないものが見つかりました。",
      "old_holds": "取り置きを解除するか販売を完了してください。",
      "undelivered_messages": "うまく処理されなかったものがあります。内容を確認してください。",
      "taxfree_failed": "旅行者への返金ができませんでした。もう一度試すか別の方法を選んでください。",
      "taxfree_deadline": "7日以内に税関確認の期限が来ます。",
      "taxfree_refund_due": "税関で確認されました。お客様に税額を返金してください。",
      "payouts_due": "委託者が入金を待っています。",
      "kobutsu_incomplete": "本人確認または必要な項目が足りません。",
      "shift_variance": "過去7日間に、締めで店長が現金の過不足を承認しました。"
    },
    "source_error": {
      "payments": "振込を確認できませんでした。",
      "orders": "注文を確認できませんでした。",
      "catalog": "商品を確認できませんでした。",
      "conflicts": "二重販売を確認できませんでした。",
      "discrepancies": "在庫の差異を確認できませんでした。",
      "holds": "取り置きを確認できませんでした。",
      "inbox": "やることリストを確認できませんでした。",
      "taxfree": "免税返金を確認できませんでした。",
      "settlements": "委託者への支払いを確認できませんでした。",
      "kobutsu": "古物台帳を確認できませんでした。",
      "pos": "レジのシフトを確認できませんでした"
    }
  },
  "kpi": {
    "title": "数字",
    "period": "期間",
    "periods": {
      "today": "今日",
      "7d": "7日間",
      "30d": "30日間"
    },
    "error": "読み込めませんでした。",
    "sales_web": "入金 — ウェブ",
    "sales_pos": "入金 — 店頭レジ",
    "payments_count_other": "{{count}} 件の支払い",
    "orders": "注文数",
    "new_cards": "登録したカード",
    "sales_note": "各チャネルの支払いとして記録された税込の入金額です。"
  },
  "activity": {
    "title": "最近の変更",
    "all": "すべての変更",
    "error": "変更履歴を読み込めませんでした。",
    "empty": "まだ変更はありません。",
    "actor": {
      "staff": "スタッフ",
      "customer": "お客様",
      "system": "システム"
    },
    "verb": {
      "created": "{{what}}を追加",
      "updated": "{{what}}を変更",
      "deleted": "{{what}}を削除",
      "status": "{{what}}の状態を変更",
      "other": "{{what}}を操作"
    },
    "entity": {
      "product": "商品",
      "variant": "商品の明細",
      "collection": "コレクション",
      "order": "注文",
      "payment": "支払い",
      "refund": "返金",
      "customer": "お客様",
      "consignor": "委託者",
      "consignment_item": "委託カード",
      "settlement": "精算",
      "payout": "支払い（委託者）",
      "unit": "在庫のカード",
      "inventory": "在庫",
      "staff": "スタッフアカウント",
      "role": "役割",
      "tax_setting": "税の設定",
      "setting": "設定",
      "page": "ページ",
      "theme": "サイトのデザイン",
      "discount": "割引コード",
      "record": "記録"
    }
  }
}
